import React from 'react';
import { services } from '../data/projectsData';

function Services() {
    return (
        <section id="services" className="py-16 md:py-24 bg-white">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
                <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
                    <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">Solutions for Every Sector</h2>
                    <p className="text-sm md:text-base text-slate-500">We solve complex business problems with tailored technology stacks designed for growth.</p>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {services.map((svc, i) => {
                        const Icon = svc.icon;
                        return (
                            <div key={i} className="group p-6 md:p-8 rounded-2xl bg-slate-50 hover:bg-white border border-slate-100 hover:shadow-xl transition-all duration-300">
                                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-blue-100 text-blue-600 flex items-center justify-center mb-5 md:mb-6 group-hover:scale-110 transition-transform">
                                    <Icon size={24} className="md:w-7 md:h-7" />
                                </div>
                                <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">{svc.title}</h3>
                                <p className="text-sm text-slate-600 leading-relaxed">{svc.desc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default Services;